import React, { useState } from "react";
import FileUploadContainer from "../../components/FileUPloadContainer/FileUploadContainer";
import TutorQuestionCard from "../../components/TutorQuestionCard/TutorQuestionCard";
import Loader from "../../components/LoaderModal";
import axios from "axios";
import CreateQuiz from "../../components/CreateQuiz/CreateQuiz";
import CopyUrlComponent from "../../components/CopyUrlComponent/CopyUrlComponent";
import InputTutorQuestionCard from "../../components/TutorQuestionCard/InputTutorQuestionCard";
import Card from "../../components/Card";
import { useTheme } from "../../context/ThemeContext";

const QuestionGenerator = () => {
    const [isLoading, setIsLoading] = useState(false); // Loading state
    const [questionGenerated, setQuestionGenerated] = useState(false);
    const [questions, setQuestions] = useState([]);
    const [loadingId, setLoadingId] = useState(null);
    const [quizUrl, setQuizUrl] = useState('');
    const { themeStyles } = useTheme();
    const [customQuestionCreatorActive, setCustomQuestionCreatorActive] = useState(false);

    const getQuestions = async (questionSetId) => {
        setIsLoading(true)
        try {
            const response = await axios.get(`${process.env.REACT_APP_BACKEND_BASEURL}/questions/set/${questionSetId}`);
            setQuestions(response.data);
            setQuestionGenerated(true);
            setIsLoading(false)
        } catch (error) {
            setIsLoading(false)
        }
    }

    // Sync function
    const handleSync = async (id) => {
        setLoadingId(id); // Set the ID of the card being loaded
        try {

            // Simulating an API call or logic for syncing
            const payload = {
                "questions": [
                    { "id": id, "isValid": false }
                ]
            }
            const response = await axios.put(
                `${process.env.REACT_APP_BACKEND_BASEURL}/questions/update-validity`, // API endpoint with ID
                payload // Payload data to be updated
            );

            // New object to replace the old one
            const newObject = response.data.newQuestion;

            const _questions = questions;

            // Find the index of the object with the target ID
            const index = _questions.findIndex((item) => item._id === id);

            if (index !== -1) {
                // Remove the old object and add the new one at the same position
                _questions.splice(index, 1, newObject);
            }
            setQuestions(_questions)
        } catch (error) {
            console.error("Sync failed:", error);
        } finally {
            setLoadingId(null); // Reset loading state after operation
        }
    };

    const handleUrl = (url) => {
        setQuizUrl(url);
    };

    const handleAddCustomQuestion = () => {
        if (!questionGenerated) {
            alert("Please generate question first");
            return
        }
        if (customQuestionCreatorActive) {
            alert("Please add upper question first");
            return
        }
        setCustomQuestionCreatorActive(true);
    }

    const questionAddedSuccess = (questionSetId) => {
        setCustomQuestionCreatorActive(false);
        getQuestions(questionSetId);
    };

    return (
        <div className="p-0 py-20 md:p-8 pb-[100px] md:pb-[100px] no-scrollbar h-full flex flex-col">
            {/* Title */}
            {isLoading && <Loader />}

            {!questionGenerated && <FileUploadContainer onQuestionSetGenerated={getQuestions} />}

            {questionGenerated && questions.map((item, index) =>
                <div key={index} className="my-5">
                    <TutorQuestionCard questionNumber={index + 1} data={item}
                        isLoading={loadingId === item._id} // Pass loading state
                        onSync={() => handleSync(item._id)} />
                </div>
            )}
            {customQuestionCreatorActive && questionGenerated && <InputTutorQuestionCard propSetId={questions[0].setId} questionAddedSuccess={questionAddedSuccess} />}
            {questionGenerated && <Card className="flex justify-center align-center mt-4">
                <button
                    type="button"
                    onClick={handleAddCustomQuestion}
                    style={{
                        marginTop: 10,
                        padding: "8px 16px",
                        borderRadius: "4px",
                        backgroundColor: themeStyles.primaryColor,
                        color: "#FFF",
                        border: "none",
                        cursor: "pointer",
                    }}
                >
                    Add Custom Question
                </button>
            </Card>}


            {questionGenerated && <CreateQuiz propQuestionSetId={questions[0].setId} handleUrl={handleUrl} />}

            {quizUrl !== "" && <CopyUrlComponent url={quizUrl} />}


        </div>
    );
};

export default QuestionGenerator;
